import type { ReactNode } from "react";
import { SiteHeader } from "@/components/landing/SiteHeader";
import { SiteFooter } from "@/components/landing/SiteFooter";
import type { Locale } from "@/lib/site";

export function SiteLayout({
  children,
  languagePaths,
}: {
  children: ReactNode;
  languagePaths?: Partial<Record<Locale, string>>;
}) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader languagePaths={languagePaths} />
      <main>{children}</main>
      <SiteFooter />
    </div>
  );
}
